const AuthUtils = {
    getAccess(resource) {
        // Valid Strings:
        //     '*' -> all orgs and practices in user's group
        //     'organization:23' -> only org 23, all practices under
        //     'practice:32' -> only practice 32
        const NO_ACCESS = { organization: null, practice: null };

        if (!resource) {
            return NO_ACCESS;
        }

        if (resource === '*') {
            return {
                organization: '*',
                practice: '*',
            };
        }

        if (resource.startsWith('organization:')) {
            let orgId = Number(resource.substring('organization:'.length));
            return {
                organization: orgId,
                practice: '*',
            };
        }

        if (resource.startsWith('practice:')) {
            let practiceId = Number(resource.substring('practice:'.length));
            return {
                organization: null,
                practice: practiceId,
            };
        }

        return NO_ACCESS;
    },
    getAccesses(resource) {
        return this.deserializeResource(resource);
    },
    deserializeResource(resourceString) {
        let roleMap = {
            a: 'Administrator',
            d: 'Document Provider',
            v: 'General Viewer',
        };
        let obj = {
            organizations: null,
            practices: null,
            consultant: false,
        };
        if (resourceString && resourceString.length > 0) {
            let resources = resourceString.split('|');
            resources.forEach(res => {
                if (res.startsWith('*')) {
                    obj.consultant = true;
                    obj.consultantRestricted = false;
                } else {
                    if (res.startsWith('@')) {
                        obj.consultant = true;
                        obj.consultantRestricted = true;
                    }
                    let r = res.split(':');
                    if (r[0] === 'o') {
                        obj.organizations = obj.organizations || {};
                        obj.organizations[r[1]] = roleMap[r[2]];
                    } else if (r[0] === 'p') {
                        obj.practices = obj.practices || {};
                        if (r[1] !== -1) {
                            // ignore the default practice with id of `-1`
                            obj.practices[r[1]] = roleMap[r[2]];
                        }
                    }
                }
            });
        }

        return obj;
    },

    serializeResourceObject(resourceObj) {
        let roleMap = {
            Administrator: 'a',
            'Document Provider': 'd',
            'General Viewer': 'v',
        };
        let resources = [];
        if (resourceObj && typeof resourceObj === 'object') {
            const orgKeys = resourceObj.organizations
                ? Object.keys(resourceObj.organizations)
                : [];
            const practKeys = resourceObj.practices
                ? Object.keys(resourceObj.practices)
                : [];
            if (resourceObj.consultant) {
                if (
                    !resourceObj.hasOwnProperty('restrictConsultant') ||
                    !resourceObj.restrictConsultant
                ) {
                    resources.push('*');
                } else {
                    resources.push('@');
                }
                if (resources.practices && resources.practices[-1]) {
                    delete resources.practices[-1];
                }
            }
            orgKeys.forEach(orgId => {
                const role = roleMap[resourceObj.organizations[orgId]] || null;
                resources.push('o:' + orgId + ':' + role);
            });
            practKeys.forEach(practId => {
                const role = roleMap[resourceObj.practices[practId]] || null;
                resources.push('p:' + practId + ':' + role);
            });
        }
        let rtv = resources.join('|');
        if (rtv === '') {
            rtv = 'p:-1:v';
        }
        return rtv;
    },
};

export default AuthUtils;
